package fr.frux.core.common.format

import kotlin.math.abs
import kotlin.math.floor
import kotlin.math.pow

fun Double.formatFixed(decimalPlaces: Int): String {
    require(decimalPlaces >= 0) { "decimalPlaces must be non-negative" }

    val factor = 10.0.pow(decimalPlaces)
    val scaledValue = floor(abs(this) * factor + 0.5).toLong()
    val wholePart = scaledValue / factor.toLong()
    val sign = if (this < 0.0) "-" else ""

    if (decimalPlaces == 0) return "$sign$wholePart"

    val fractionalPart = (scaledValue % factor.toLong())
        .toString()
        .padStart(decimalPlaces, '0')
    return "$sign$wholePart.$fractionalPart"
}
